var app = {

	init: function () {
		this.parallax();
		this.scrollSpy();
		this.navActive();
		this.scrollHome();
	}, 

	parallax: function () {
		$('[data-parallax="scroll"]').parallax();
	}, 

	scrollSpy: function () {

		$(".scroll-spy").click(function(e) {

		   e.preventDefault();

		   var hash = this.hash;

		   $('html, body').animate({
		       scrollTop: $(hash).offset().top - $('.tg-navigationarea').height()
		     }, 300, function(){
		       window.location.hash = hash;
		     });

		});

	}, 

	navActive: function () {

		$('.tg-navigation a').click(function () {

			var li = $(this).closest('li');

			$('.tg-navigation li').removeClass('tg-active');
			$(li).addClass('tg-active');

		});

	}, 

	scrollHome: function () {

		if ( $('#page').val() == 'home' ) {

			$(".scroll-to").click(function(e) {

			   e.preventDefault();

			   var hash = this.hash;

			   $('html, body').animate({
			       scrollTop: $(hash).offset().top - $('.tg-navigationarea').height()
			     }, 300, function(){
			       window.location.hash = hash;
			     });

			});

		}

	}

	
}
//# sourceMappingURL=all.js.map
